module.exports = __webpack_public_path__ + "img/user-small.24bf67f2.svg";